import { useContext, useEffect, useState } from 'react';
import Select, { MultiValue } from 'react-select';
import { AppContext } from '../../../context';

interface Props {
    onChange: (selectedIds: number[]) => void;
    value: number[];
}

export const WorkshiftMultiSelector = ({ onChange, value }: Props) => {
    const { langResources, isSkinSmart, workshiftList } = useContext(AppContext);

    const handleChange = (
        newValue: MultiValue<{ label: string; value: number }>
    ) => {
        const selectedIds = newValue.map((option) => option.value);
        onChange(selectedIds);
    };

    const workshiftsOptions = [
        ...workshiftList.map((contractor) => ({
            label: contractor.alias.toUpperCase(),
            value: contractor.id,
        })),
    ];

    const defaultOptions = (
        values: number[]
    ): MultiValue<{ label: string; value: number }> => {
        let options = values.map((value) => {
            return {
                value: value,
                label: workshiftList.find((w) => w.id === value)?.name ?? '',
            };
        });

        return options;
    };

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Selecciona los turnos para filtrar la programación
            </label>
            <Select
                id='multi-selector-workshifts'
                isMulti
                name='allContractors'
                options={workshiftsOptions}
                className=' '
                isClearable={true}
                isSearchable={true}
                placeholder='Seleccione'
                onChange={handleChange}
                value={defaultOptions(value)}
            />
        </div>
    );
};
